import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import { TriggerFoundationFilter, } from '@debbie/common/dist/procedures/index.js';
import { useBillingModels } from '@debbie/cortex/dist/billing-models/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useProcedures } from '@debbie/cortex/dist/procedures/index.js';
import { useUserById } from '@debbie/cortex/dist/users/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ButtonDrop from '../../ButtonDrop.js';
import { Table } from '../../index.js';
import { foundationFilterLabels, foundationFilterOf, timingText, } from '../../procedures/labels.js';
import { Meta } from './style.js';
export const SettingsDetails = ({ blamelog }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                React.createElement(SettingsDetailsContent, { blamelog: blamelog })))));
};
const SettingsDetailsContent = ({ blamelog }) => {
    switch (blamelog.type) {
        case BlameLogType.AutoDebtRegister:
        case BlameLogType.AutoRegisterInOpenRegistry:
        case BlameLogType.AutoIgnoreUnresolvedOppositions:
        case BlameLogType.AutoDeleteDebtRegistrationOnCaseEnd:
        case BlameLogType.RKIOveride:
        case BlameLogType.AKSActivated:
            return React.createElement(ToggleSettingContent, { blamelog: blamelog });
        case BlameLogType.AKSConfiguration:
            return React.createElement(AKSConfigurationContent, { blamelog: blamelog });
        case BlameLogType.AKSClientID:
            return React.createElement(AKSClientIDContent, { blamelog: blamelog });
        case BlameLogType.PriceList:
            return React.createElement(PriceListContent, { blamelog: blamelog });
        case BlameLogType.UserPasswordUpdate:
            return React.createElement(UserPasswordUpdateContent, { blamelog: blamelog });
        case BlameLogType.TriggerShortcut:
            return React.createElement(TriggerShortcutContent, { blamelog: blamelog });
        case BlameLogType.ConnectorBillingUpdate:
            return React.createElement(ConnectorBillingUpdateContent, { blamelog: blamelog });
        case BlameLogType.CreditorSettingsUpdate:
            return React.createElement(CreditorSettingsUpdateContent, { blamelog: blamelog });
        default:
            return null;
    }
};
// Generic toggle settings (debt register auto settings, RKIOveride, AKSActivated)
const ToggleSettingContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null, typeof details.toggled !== 'undefined' && details.toggled !== null && (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.toggled)),
        React.createElement("td", null, details.toggled
            ? lang.blameLogs.trueActivated
            : lang.blameLogs.falseActivated)))));
};
const AKSConfigurationContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        details.keyChanged && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.key)),
            React.createElement("td", null, lang.blameLogs.trueChanged))),
        details.codeChanged && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.code)),
            React.createElement("td", null, lang.blameLogs.trueChanged))),
        details.usernameChanged && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.username)),
            React.createElement("td", null, lang.blameLogs.trueChanged))),
        details.passwordChanged && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.password)),
            React.createElement("td", null, lang.blameLogs.trueChanged)))));
};
const AKSClientIDContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null, details.clientId && (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement("b", null, lang.blameLogs.experianClientId)),
        React.createElement("td", null,
            lang.blameLogs.trueChanged,
            " ",
            lang.blameLogs.to,
            ": ",
            details.clientId)))));
};
const PriceListContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    // Blame logs written before the rename stored the fee under its old
    // RKI-prefixed key; keep those historical entries readable.
    const priceList = {
        ...details.priceList,
        debtRegisterRegistrationFee: details.priceList.debtRegisterRegistrationFee ??
            details.priceList
                .RKIRegistrationFee,
    };
    const priceListFields = [
        {
            key: 'debtRegisterRegistrationFee',
            label: lang.tenants.debtRegisterRegistrationFee,
        },
        { key: 'afslysningAfUdlaeg', label: lang.tenants.afslysningAfUdlaeg },
        { key: 'anmeldelseAfKravFee', label: lang.tenants.anmeldelseAfKravFee },
        { key: 'caseCloseFee', label: lang.tenants.caseCloseFee },
        { key: 'clientCaseCreationFee', label: lang.tenants.clientCaseCreationFee },
        { key: 'fogedrekvisitionsFee', label: lang.tenants.fogedrekvisitionFee },
        {
            key: 'folkeregisteropslagsFee',
            label: lang.tenants.folkeregisteropslagsFee,
        },
        { key: 'legalAdviceHourlyRate', label: lang.tenants.legalAdviceHourlyRate },
        { key: 'paymentDemandFee', label: lang.tenants.paymentDemandFee },
        { key: 'tenantCaseCreationFee', label: lang.tenants.tenantCaseCreationFee },
    ];
    return (React.createElement(React.Fragment, null, priceListFields.map(({ key, label }) => priceList[key] != null && (React.createElement("tr", { key: key },
        React.createElement("td", null,
            React.createElement("b", null, label)),
        React.createElement("td", null,
            lang.blameLogs.trueChanged,
            " ",
            lang.blameLogs.to,
            ":",
            ' ',
            priceList[key]))))));
};
const UserPasswordUpdateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    const userLoader = useUserById(details.userId);
    const user = h.hasData(userLoader) ? userLoader.data : null;
    return (React.createElement(React.Fragment, null,
        user?.firstName && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.users.firstName)),
            React.createElement("td", null, user.firstName))),
        user?.lastName && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.users.lastName)),
            React.createElement("td", null, user.lastName))),
        user?.email && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.users.email)),
            React.createElement("td", null, user.email)))));
};
const TriggerShortcutContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    const proceduresLoadable = useProcedures();
    const procedures = h.hasData(proceduresLoadable)
        ? proceduresLoadable.data
        : null;
    const selectedProcedures = procedures && details.procedureId
        ? procedures.filter((p) => details.procedureId.includes(p.procedureId))
        : [];
    const procedureTitle = (procedureId) => procedures?.find((p) => p.procedureId === procedureId)?.title ??
        procedureId;
    // Configured triggers carry per-configuration settings, so listing the
    // procedures alone would render a timespan-only edit identically to the
    // entry before it.
    const configurations = details.configurations ?? null;
    const filterLabels = foundationFilterLabels(lang);
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.when)),
            React.createElement("td", null, lang.triggers[details.systemProcedure])),
        configurations !== null
            ? configurations.map((configuration, idx) => {
                const foundationFilter = foundationFilterOf(configuration);
                return (React.createElement("tr", { key: idx },
                    React.createElement("td", null,
                        React.createElement("b", null, timingText(lang, configuration)),
                        foundationFilter !== TriggerFoundationFilter.Any && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            filterLabels[foundationFilter]))),
                    React.createElement("td", null, configuration.procedureIds.map(procedureTitle).join(', '))));
            })
            : selectedProcedures.length > 0 && (React.createElement("tr", null,
                React.createElement("td", null,
                    React.createElement("b", null, lang.blameLogs.procedure)),
                React.createElement("td", null, selectedProcedures.map((p) => p.title).join(', '))))));
};
const ConnectorBillingUpdateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    const billingModelsLoadable = useBillingModels();
    const billingModels = h.hasData(billingModelsLoadable)
        ? billingModelsLoadable.data
        : null;
    const billingModel = billingModels?.find((bm) => bm.billingModelId === details.billingModelId);
    return (React.createElement(React.Fragment, null,
        typeof details.dunning !== 'undefined' && details.dunning !== null && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.dunning)),
            React.createElement("td", null, details.dunning ? lang.blameLogs.trueYes : lang.blameLogs.falseNo))),
        billingModel && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.connectorBillingModel)),
            React.createElement("td", null, billingModel.name)))));
};
const CreditorSettingsUpdateContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    // Generic rendering for creditor settings
    return (React.createElement(React.Fragment, null, Object.keys(details).map((key) => (React.createElement("tr", { key: key },
        React.createElement("td", null,
            React.createElement("b", null, lang.creditors[key] ||
                key)),
        React.createElement("td", null, JSON.stringify(details[key])))))));
};
//# sourceMappingURL=SettingsDetails.js.map